import { AsyncThunkAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { getAllUsers } from "../../../store/slices/userListSlice";

export function refreshUserTable(dispatch: Dispatch<AsyncThunkAction<any, any, any>>) {
    const paramaters: any = {
        userCode: "",
        userName: "",
        email: "",
        phone: "",
        userTypeId: null,
        status: 0
    }
    dispatch(getAllUsers(paramaters));
}